/**
 * ChartTip — custom Recharts tooltip dùng tokens.
 *
 * Recharts default tooltip nền trắng + border đen, không khớp design.
 * Truyền vào `<Tooltip content={<ChartTip />} />`.
 */
import { formatIntVN } from "@/lib/format";

type ValueFormatter = (value: number, name?: string) => string;

type TipPayload = {
  name?: string | number;
  value?: number | string;
  color?: string;
};

type Props = {
  active?: boolean;
  payload?: TipPayload[];
  label?: string | number;
  formatter?: ValueFormatter;
};

export function ChartTip({ active, payload, label, formatter }: Props) {
  if (!active || !payload || payload.length === 0) return null;
  return (
    <div className="rounded-md border border-border bg-surface px-3 py-2 text-xs shadow-md">
      {label != null ? (
        <div className="mb-1 font-medium text-foreground">{String(label)}</div>
      ) : null}
      <div className="space-y-0.5">
        {payload.map((p, i) => {
          const v = typeof p.value === "number" ? p.value : Number(p.value ?? 0);
          const name = typeof p.name === "string" ? p.name : String(p.name ?? "");
          const text = formatter ? formatter(v, name) : formatIntVN(v);
          return (
            <div key={i} className="flex items-center gap-2">
              <span
                aria-hidden
                className="inline-block h-2 w-2 rounded-full"
                style={{ background: p.color ?? "var(--color-brand)" }}
              />
              <span className="text-muted-foreground">{name}</span>
              <span className="ml-auto font-medium text-foreground">{text}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
